import axios from "axios";
import { BASE_URL } from "./url";
import { useSgcqStore } from "@/stores/SgcqStore";

const httpClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Accept": "*/*",
    "Content-type": "application/json",
  },
});

httpClient.interceptors.request.use(
  function (config) {
    const store = useSgcqStore();
    const token = store.getToken;
    if (token) {
      config.headers.Authorization = "Bearer " + token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default httpClient;
